export const ContentTypes = {
  TEXT: 'TEXT',
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
} as const;

export type ContentType = keyof typeof ContentTypes;
